import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ typography }) =>
  createStyles({
    main: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      '& > button': {
        margin: 0,
        padding: 0,
        width: 'max-content',
        height: 'max-content',
        textWrap: 'nowrap',

        fontSize: typography.pxToRem(13),
        fontWeight: typography.fontWeightMedium,

        color: '#FFF',
      },
    },
  }),
)
